<template>
    <div :class="['site-entry', {alt: index % 2 != 0}]">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-lg-5 site-column d-print-none">
                    <div class="carousel-holder">
                        <carousel v-bind="carouselOptions"
                                  :navigation-next-label="nextLabel"
                                  :navigation-prev-label="prevLabel"
                                  class="carousel"
                        >
                            <slide v-for="photo in photos" 
                                   :key="photo.title"
                                   class="photo"
                            >
                                <div class="featured-image shadow" :style="`background-image:url(${photo.permalink + urlParams(photo)});`"></div>
                            </slide>
                        </carousel>
                    </div>
                </div>
                
                <div class="col-12 col-lg-7 col-print-12 entry-column">
                    <h2>{{ entry.title }}</h2>
                    <p v-if="entry.description" v-html="entryDescription"></p>
                    
                    <div class="entry-site-info">
                        <h4 class="mt-4"><BetterLink class="site-link" :to="{ name: 'Site', params: { id: entry.site.slug } }">Find out more about {{ entry.site.name }} <fa-icon :icon="['fal', 'arrow-right']" /></BetterLink></h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: 'SiteEntry',
    components: {
        Carousel,
        Slide,
    },
    props: {
        index: {
          type: Number,
        },
        entry: {
          type: Object,
          required: true,
        },
    },
    data() {
        return {
            carouselOptions: {
                perPage: 1,
                scrollPerPage: true,
                navigationEnabled: true,
                paginationEnabled: false,
            },
            prevLabel: '<svg data-v-23de9137="" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-2x" style="vertical-align: -0.35em;"><path data-v-23de9137="" fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg>',
            nextLabel: '<svg data-v-23de9137="" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-2x" style="vertical-align: -0.35em;"><path data-v-23de9137="" fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg>',
        }
    },
    computed: {
        entryDescription() {
            let description = this.$autoP(this.entry.description)
            let paras = (description.match(/<p>/g) || []).length
            
            if (this.entry.callout != '' && paras > 1) {
                let parts = description.split('</p>')
                parts[1] = `<p class="callout" ${this.$options._scopeId}>${this.entry.callout}</p>${parts[1]}`
                description = parts.join('</p>')
            } else if (this.entry.callout != '' && paras == 1) {
                description = `<p class="callout" ${this.$options._scopeId}>${this.entry.callout}</p>${description}`
            }
            
            return description
        },
        photos() {
            let entryPhotos = this.entry.photos
            let entryPhotoIds = this.entry.photos.map(photo => photo.id)
            let excludedPhotos = [...entryPhotoIds, ...(this.entry.excluded_media || [])]
            let sitePhotos = this.entry.site.photos.filter(photo => excludedPhotos.indexOf(photo.id) == -1)
            
            return [...entryPhotos, ...sitePhotos]
        },
    },
    methods: {
        urlParams(photo) {
            if (photo.params) {
                let params = JSON.parse(photo.params)
                return '?w=1600&ar=1.85:1&' + Object.objectAsQueryString(params)
            }
            return '?w=1600&ar=1.85:1&fit=crop&crop=faces,entropy'
        },
    }
};
</script>

<style lang="scss" scoped>
.site-entry {
    position: relative;
    padding: 100px 0;
    background: $off-white;
    color: initial;
    
    .row {
        flex-direction: row-reverse;
    }
    
    h2 {
        font-family: "Salome Fine";
        font-size: 7vw;
        line-height: 7.5vw;
    }
    
    p {
        font-size: 18pt;
        
        &.callout {
            font-family: "Argesta Headline Regular Italic";
            font-size: 170%;
            margin: 40px 0;
        }
    }
    
    .carousel-holder {
        position: sticky;
        top: 100px;
        padding-left: 20px;
        padding-right: 20px;
    }
    .carousel {
    }
    .featured-image {
        width: 100%;
        height: 0;
        padding-top: 54%;
        background-size: cover;
        background-position: center center;
        overflow: initial;
        
        @media (max-width: 991.98px) {
            margin-bottom: 40px;
        }
    }
    
    .site-link {
        font-family: "Argesta Headline Regular Italic";
        font-size: 170%;
    }
    
    &.alt {
        background: $primary;
        color: white;
        
        .row {
            flex-direction: row;
        }
        
        .site-link {
            color: white;
        }
    }
}
</style>